import React from 'react';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import BookingThankyou from '../../images/booking_thankyou.png';
import useClientsEventBookingContext from './hooks/useClientsEventBookingContext';

function Thankyou() {
  const { Grid, Button } = useUiContext();

  const { clientsEventBooking } = useClientsEventBookingContext();

  const { clientAttributes: { email } } = clientsEventBooking;

  const Title = () => (
    <div className="text-container">
      <h1>Thank you!</h1>
      <p>Thank you for submitting your details.</p>

      <p> Please create an account in order to access your information and manage your appointment</p>
    </div>
  );

  const moveToCreateAccount = () => {
    window.location.replace(`${process.env.PROXY_PATH}/profile/clients/sign_up?client[email]=${email}`);
  };

  return (
    <div className="appointment-confirmation-wrapper">
      <Title />
      <Grid container justify="center" spacing="3">
        <Grid item xs={12}>
          <div className="mobile-img-wrapper">
            <img src={BookingThankyou} alt="Booking confirmed" />
          </div>
        </Grid>
        <Grid item xs={12} md={12}>
          <h1> Thank you</h1>
        </Grid>

      </Grid>
      <Grid container className="confirmed-actions-wrapper">
        <div className="form-btn left-align primary-btn">
          <Button onClick={moveToCreateAccount}>Create Account</Button>
        </div>
      </Grid>
    </div>
  );
}

export default Thankyou;
